import { render, staticRenderFns } from "./index_new.vue?vue&type=template&id=51a66c85&scoped=true&"
import script from "./index_new.vue?vue&type=script&lang=js&"
export * from "./index_new.vue?vue&type=script&lang=js&"
import style0 from "./index_new.vue?vue&type=style&index=0&id=51a66c85&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a66c85",
  null
  
)

export default component.exports